import React from "react";
import Section from "../components/Section";

const SERVICES = [
  ["📊", "Microsoft AppCenter Analytics & Crash Reporting", "Collects anonymised crash reports and usage events tied to the device identifier to help us improve stability and performance."],
  ["🔥", "Google Firebase Analytics", "Tracks anonymised in-app events and screen views using the device identifier to help us understand feature engagement."],
  ["🔔", "OneSignal Push Notifications", "Manages delivery of push notifications using a push token linked to the device identifier. No personal data is shared with OneSignal."]
];

function ThirdPartyServices() {
  return (
    <Section id="third-party" icon="🔗" title="Third-Party Services">
      <p>
        The App integrates with the following third-party services. Each service operates under its own
        privacy policy. We share only the minimum data necessary for each service to function.
      </p>

      <div className="third-party-list">
        {SERVICES.map(([icon, name, desc]) => (
          <div className="third-party-item" key={name}>
            <div className="tp-icon">{icon}</div>
            <div>
              <h4>{name}</h4>
              <p>{desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="info-box" style={{ marginTop: "20px" }}>
        We do not sell, rent, or trade any data — including device identifiers — to advertisers,
        data brokers, or any other third party for commercial purposes.
      </div>
    </Section>
  );
}

export default ThirdPartyServices;
